import React, { useState, useEffect} from "react";
import { RCCColorPicker } from "react-common-components";
import { useForm } from "react-hook-form";
import EditableTitle from "src/components/EditableTitle";
import SortableHandle from "src/components/Sortable/Handle";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import returnColor from "src/utils/returnColor";
import textColorBasedOnBackground from "src/utils/textColorBasedOnBackground";
import Handle from "../DroppableContainer/components/Handle";
import Remove from "../DroppableContainer/components/Remove";
import { Actions, CounterNumberOfItems, Header, Label, WrapContainer } from "./styles";

export interface Props {
	placeholder?: boolean;
	label?: string;
	onChangeColorColumn?: Function;
	onChangeTitleColumn?: Function;
	color?: string;
  onRemove?(): void;
	noStyle?: boolean;
	columns?: number;
  children: React.ReactNode;
	handleProps?: React.HTMLAttributes<any>;
	style?: React.CSSProperties;
	onClick?(): void;
	numberOfItems: number;
	isDefaultColumn?: boolean;
	permission?: number;
}

const Container: React.FC<Props> = (
	{
		children,
		color,
		onRemove,
		onChangeColorColumn,
		onChangeTitleColumn,
		label,
		placeholder,
		noStyle,
		numberOfItems,
		onClick,
		isDefaultColumn = false,
		permission = 2
	}: Props
) => {
	const { control } = useForm();
	const { superUser, administrator, checkIfHasSpecificPermission } = useAuth();
	const {translate} = useTranslation();

	const [colorColumn, setColorColumn] = useState<string>(color || "#4B77BE");

	const colorChange = (newColor: string) => {
		if(onChangeColorColumn){
			setColorColumn(newColor);
			onChangeColorColumn(newColor);
		}
	};

	const titleChange = async (newTitle: string) => {	
		if(onChangeTitleColumn)
			await onChangeTitleColumn(newTitle);
	};

	useEffect(() => {
		if(color)
			setColorColumn(color);
	}, [color]);


	const isDefaultTile = (x: string) => {
		const defaultTitles = ["Não iniciado", "Em andamento", "Concluído", "Nova coluna"];
		const contains = defaultTitles.includes(x);
		if(contains)
			return translate(x);
		
		return x;
	};

	return (
		<WrapContainer
			placeholderProp={placeholder}
			onClick={onClick}
			tabIndex={onClick ? 0 : undefined}
			widthFlex={noStyle}
			noStyle={noStyle}
			isDefaultColumn={isDefaultColumn}
		>
			{label && !placeholder ? (
				<Header>
					<Label color={returnColor(colorColumn) }>
						<EditableTitle
							onSubmit={titleChange}
							value={isDefaultTile(label)}
							colorBorderInput={returnColor(colorColumn)}
							maxLength={60}
							resize={false}
							pencilIcon={false}
							titleProps={{
								color: "black",
								styleInline: `
									color: ${textColorBasedOnBackground(returnColor(colorColumn) ?? "#d3d3d3")}; 
									display: -webkit-box;
									-webkit-line-clamp: 1;
									-webkit-box-orient: vertical;
									word-break: break-all; `
							}}
							disabled={isDefaultColumn || !((superUser || administrator || permission >= 2) && checkIfHasSpecificPermission("actions/kanban", PermissionEnum.CREATE_UPDATE))}
							heightInput="27px"
						/>
					</Label>
					<Actions>

						{!isDefaultColumn && ((superUser || administrator || permission >= 2) && checkIfHasSpecificPermission("actions/kanban", PermissionEnum.CREATE_UPDATE_DELETE)) && (
							<Remove onClick={onRemove} />
						)}

						{numberOfItems > 0 && (
							<CounterNumberOfItems>
								{numberOfItems}
							</CounterNumberOfItems>
						)}

						{!isDefaultColumn && ((superUser || administrator || permission >= 2) && checkIfHasSpecificPermission("actions/kanban", PermissionEnum.CREATE_UPDATE)) && (
							<>
								<RCCColorPicker
									name="colorColumn"
									onColorChange={(colorX) => colorChange(colorX)}
									control={control}
									colorPickerProps ={{color:returnColor(colorColumn)}}
									showPointer={false}
									position="leftEnd"
									defaultValue = {returnColor(colorColumn)}
								/>
								<SortableHandle>
									<Handle /> 
								</SortableHandle>
							</>
						)}

					</Actions>
				</Header>
			) : null}

			{placeholder ? <p style={{ color: "var(--grey-darker)"}}> {children} </p>  : (
				<div style={{ overflow: "scroll", height: "100%" }}>
					<ul>{children}</ul>
				</div>	
			)}

		</WrapContainer>
	);
};

export default Container;
